import Vue from 'vue'
import router from './router'
import App from './App.vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

import './plugins/vueamap.js' //  vue-amap 高德地图
import './plugins/element.js' //  elemnt组件
import { formatDate } from './plugins/function.js' // 公共方法
import lang_zh from './assets/lang/zh'
import lang_zh_HK from './assets/lang/zh_HK'
import lang_en from './assets/lang/en'
import '../public/fonts/iconfont.css' // 阿里图标
import '../public/style.css' // 公共CSS
import './assets/icons'
import './assets/css/flex.scss'
import skeleton from 'vue-skeleton-component' // 骨架
import store from './store/index.js'

import { VueJsonp } from 'vue-jsonp'
Vue.use(VueJsonp)

import { isEmpty } from './utils/index.js'
Vue.prototype.$isEmpty = isEmpty;
Vue.prototype.$platform = 0
Vue.prototype.$macao_phone = /^(853)?(?:28\d{6}|6\d{7})$/
Vue.prototype.$pdw_str = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,18}$/
Vue.prototype.$phone_str = /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/
// 时间格式化
Vue.filter('formatDate', function (time) {
    var date = new Date(time * 1000);
    return formatDate(date, 'yyyy-MM-dd hh:mm');
});

Vue.filter('formatDateAuto', function (time, str) {
    var date = new Date(time * 1000);
    return formatDate(date, str);
});

// 检测是否有登录
Vue.prototype.$checkLogin = function () {
    const isLogin = store.getters.isLogin
    return new Promise(function (resolve, reject) {
        if (isLogin) {
            resolve(true)
        } else {
            router.push('/login')
        }
    })
}

Vue.config.productionTip = false


Vue.use(skeleton); // 骨架

// 跳转后返回顶部
router.afterEach(() => {
    window.scrollTo(0, 0);
})

// 国际化
// 国际化
const i18n = new VueI18n({
    locale: window.localStorage.getItem('locale') || 'zh_HK',
    messages: {
        zh: lang_zh,
        zh_HK: lang_zh_HK,
        en: lang_en
    }
})

new Vue({
    router,
    i18n,
    store,
    render: h => h(App)
}).$mount('#app')